export const defaultColours = {
	primary: '#F5981F',
	secondary: '#1e4077',
	dark: '#16315B',
	light: '#f5f5f5',
};
